'use strict';

class LatestNews {

	constructor($target) {

		//Private properties
		$target;

		var limitPerPage = 6;
		var currentPage = 1;
        var $currentPage = $target.find('.block_latest_news__pagination__current_page');
        var arrayLength = $target.find('.block_latest_news__article').length;
        var $items = $target.find('.block_latest_news__article');
        var totalPages = Math.ceil(arrayLength / limitPerPage);
        
        $items.hide();
		$currentPage.html(currentPage);

		let name = "HELLO";

		function init(){
			pagination();
		}

		function pagination(){

			changePage();

			// setting up inactive state on new posts for page load
			if (currentPage == 1) {

				$('.button_prev').addClass("inactive")
				
			}

			// disable the next button if we have less than the pagination
			if($items.length <= limitPerPage)
			{
				$('.button_next').addClass("inactive")
			}

			// function to increase page number when clicking older posts 
			$('.button_next').on('click', function(){

				if (currentPage < totalPages){
					currentPage++;
					scrollToTop()
				}

				if($('.button_prev').hasClass("inactive")){
					$('.button_prev').removeClass("inactive")
				}

				if (currentPage == totalPages) {
					$('.button_next').addClass("inactive")
				}

				changePage();

			});

			// function to decrease page number when clicking newer posts 
			$('.button_prev').on('click', function(){

				if (currentPage > 1){
					currentPage--;
					scrollToTop()
				}

				if($('.button_next').hasClass("inactive")){
					$('.button_next').removeClass("inactive")
				}

				if (currentPage == 1) {
					$('.button_prev').addClass("inactive")
				}

				changePage();

			});
			function scrollToTop(){
				window.scrollTo(0,$target.offset().top - $('.top_nav_container__content').height());
			}
			// change page funtion that displays the items on the page 
			function changePage() {
				$items.hide();
				$currentPage.html(currentPage);
				$($items[currentPage * limitPerPage - 1]).show();
				$($items[currentPage * limitPerPage - 2]).show();
				$($items[currentPage * limitPerPage - 3]).show();
				$($items[currentPage * limitPerPage - 4]).show();
				$($items[currentPage * limitPerPage - 5]).show();
				$($items[currentPage * limitPerPage - 6]).show();
			}
			
    	}
        

		init()
		return {

			//Public properties
			name:name,

			publicBlockHero:function(string){

				// $target.append("HELLO!"+string);
				// console.log(name)
				// console.log(string)
				// console.log($target)

			}

		}

	}

}

export default LatestNews;